import { getCustomTheme } from 'src/theme'
import { ThemeProvider } from 'styled-components'

export const CustomThemeProvider = ({ children }: { children: Children }): JSX.Element => {
  const theme = getCustomTheme({ mode: 'light' })

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
